import { MenuItem, SxProps } from "@mui/material";
import type { MenuItemProps } from "@mui/material/MenuItem";
import { KeyboardEvent, ReactNode } from "react";

interface FilterMenuItemProps extends Omit<MenuItemProps, "onKeyDown"> {
  label?: string;
  children?: ReactNode;
  to?: string;
  onKeyDown?: (
    event: KeyboardEvent<HTMLLIElement>,
    label: string | undefined,
  ) => void;
}

export function FilterMenuItem({
  label,
  children,
  onClick,
  value,
  sx = [],
  onKeyDown,
  ...rest
}: FilterMenuItemProps) {
  return (
    <MenuItem
      key={label}
      value={value}
      sx={[
        { px: 1, borderRadius: "4px", whiteSpace: "initial" },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
      onClick={onClick}
      tabIndex={0}
      onKeyDown={(event) => onKeyDown?.(event, label)}
      {...rest}
    >
      {children}
    </MenuItem>
  );
}
